module.exports = __webpack_public_path__ + "media/images/countrysquared/gg-62a9af310f71f888e419569b06322ca3.svg";